export default {
  '/KxreR': '庫存準時率',
  '2MYr1m': '登錄',
  '4/Lg7X': '請輸入登錄密碼',
  '7wofGo': '應用',
  '9UZxwP': '請輸入驗證碼',
  'AUuPe6': '至少輸入{num}個字符，雙擊切換至批量查詢',
  'BC74I9': '提示信息',
  'BG+fLq': '幫助指南',
  'CLqPBU': '編輯',
  'CMMjhY': '列展示',
  'Gwj7xc': '恢復默認',
  'I1vr0V': '找回密碼',
  'J9jPRL': '復製成功',
  'MhOy8s': '至少輸入{num}個字符',
  'N5Lfmq': '不允許的文件格式',
  'OQBMaY': '郵箱登錄',
  'USKhsn': '搜索的 "{keyword}" 的結果',
  'UtE0dS': '操作',
  'VaYh5v': '記住密碼',
  'WgC6Gs': '正在導出中, 稍後可在 「<url>導出中心</url>」 查看',
  'XeiAal': '刪除',
  'Xjfb5m': '隱私政策',
  'YpskxZ': '出庫準時率',
  'bqbDVw': '查詢',
  'byKmgP': '{start} 至 {end}， 共 {total} 條記錄',
  'eZAtxt': '字段展開',
  'fxYWiK': '請輸入郵箱',
  'gI0VX4': '準時投遞率',
  'gP0n6A': '開頭是',
  'gSS3He': '聯系人姓名',
  'hOA76J': '等於',
  'lSOSkG': '結尾是',
  'oIbf2X': '上架準時率',
  'pVp/bh': '請選擇文件上傳',
  'qUKj7E': '復製',
  'r2dEd/': '重置',
  'sIy67M': '包含',
  'uB9dmc': '當前賬號暫無<strong>{menuName}</strong>菜單權限，請聯系主賬號開啟',
  'usAYZQ': '最多支持{num}個查詢',
  'xUjLTE': '搜索',
  'y5s4nK': '至少輸入2個字符',
  'zUjHmW': '<strong>抱歉，沒有找到與「{keyword}」相關的文檔</strong>{break} 建議您：{break} 看看輸入的文字是否有誤{break} 去掉可能不必要的字詞，如「的」、「什麽」等',
  'zbkYlG': '萬邑通全場景高效海外{break}賣得好、備得少、綜合成本就是少',
  'zkVUHd': '最多查詢{num}個，雙擊切換至單個查詢',
  'zvNTfS': '進入指南',
  '+UIRGl': '發票匯總',
  '0AJzSm': '發票稅額',
  '1WB+di': '處理異常',
  '2QzYmY': '取消',
  '47GdDb': '關閉',
  '4KPJBi': '文件大小請勿超過{attachmentSizeMax}M，請壓縮後上傳',
  '4vcHWR': '附件格式/數量:支持格式{attachmentFileFormat},最多上傳{attachmentNumMax}個附件,每個附件不超過{attachmentSizeMax}M。(圖片上傳成功後暫不支持預覽功能)',
  '99qdsf': '超期發票金額',
  '9j7Ejw': '上傳附件',
  'A64kW0': '最多上傳 {maxCount} 個文件',
  'F7+3p7': '發票號',
  'HNFUfF': '請上傳附件!',
  'J0D5h+': '開始時間',
  'JN5iZt': '提交成功',
  'PzFarD': '總發票金額',
  'Q06UZa': '發票明細',
  'T8gjTZ': '文件名不能包含空格',
  'U5K9ww': '上傳發票',
  'Wy9Mf2': '今天',
  'XQVNb1': '賬單區間',
  'YKwdXz': '退回原因',
  'eUSpdN': '查看更多',
  'eydz7g': '應付日期',
  'i0bc3f': '幣種',
  'jESlL9': '近{days}天',
  'nEqIuQ': '開票日期',
  'ns1bWF': '請選擇賬單區間',
  'osngNl': '發票文件',
  'ptv3HC': '流程中發票金額',
  'qaOnvz': '已付款發票金額',
  'qdvxnx': '文件格式限製為{allowExtensions}',
  'r0/TUu': '確定',
  'rLn5dB': '查看明細',
  'sQOTXH': '發票金額',
  'v04auv': '結束時間',
  'v5/qhM': '賬單狀態',
  '+Y0zrA': '我們向您發送電子郵件以驗證您的賬戶，請檢查您的 {email} 收件箱並完成驗證{break}如果您未收到郵件，<reSend>點擊這裏</reSend>請求重新發送',
  '6AJEH3': '新密碼',
  '6Y0p2/': '下一步',
  'DQMC7I': '兩次密碼輸入不一致',
  'FEb7U2': '確認',
  'FKnMw9': '確認密碼',
  'KOOqT/': '密碼修改成功！',
  'Q4T2WD': '此明細列表會展示系統自動識別的發票信息，當識別失敗時，無對應明細，會由後臺人員進行信息補充',
  'S0RL7L': '忘記密碼',
  'S0h9rp': '6-32位數字、字母、標點符號',
  'Vcz4jn': '設置成功',
  'W7shU1': '提供賬號信息',
  'YcmSjW': '請輸入新密碼',
  'Z5Nevj': '修改密碼',
  'common.changePwd': '修改密碼',
  'eEwaYk': '記得密碼？返回<login>登錄</login>',
  'f+xVln': '請輸入確認密碼',
  'gsk33w': '重置密碼',
  'hDx3/S': '郵箱',
  'sPM43N': '前往郵箱',
  't0nA+i': '安全驗證',
  '4TdPpv': '超期發票金額：狀態=審核中、審核不通過、請款中，且已超過應付日期的發票金額合計',
  'LibxI+': '總發票金額：歷史至今所有的發票金額合計',
  'hOA0jT': '已付款發票金額：狀態=已付款的發票金額合計',
  'zzAMrk': '流程中發票金額：狀態=審核中、審核不通過、請款中的發票金額合計',
  '7Op7Wj': '舊密碼',
  'TAdFnk': '確認新密碼',
  'yTXeo9': '發票管理',
  '4R5GEq': '首頁',
  'blEKts': '請輸入舊密碼',
  '1W7mP7': '阿拉斯加時間',
  'DBKT4U': '供應商',
  'Lu0LkA': '車型',
  'QSV2/G': '訂單號',
  'QV3pnn': '狀態',
  'R2D5Dv': '創建時間',
  'WNISgN': '美西時間',
  'YJGPnI': '提貨點',
  'Yqf2Bb': '運輸號',
  'aloI6s': '美東時間',
  'dpTOZD': '車輛中轉單',
  'fa/Ner': '夏威夷時間',
  'g+RRVq': '中國標準時間',
  'gQ4+K1': '日期',
  'ghWyE2': '運輸單',
  'hCaFQn': '下載憑證',
  'hEQR93': '線路',
  'j05yAV': '美中時間',
  'sSmyfa': '卸貨點',
  'vGUm/N': '美山地時間',
  '0mnS/Y': '成功數量:{successNum}, 失敗數量:{failNum}, 失敗數據文件:{a1}',
  '30EC+P': '申請時間',
  '36+mbi': '處理狀態',
  '4W0sU4': '請輸入供應商說明',
  '6OSI7c': '查件管理',
  '7XrXMP': '查件備註',
  '8bfXLo': '查件類型',
  'AqMNVt': '批量更新查件結果',
  'BYgheS': '下載文件模板',
  'I/NzUV': '查件結果為「有POD」，需要上傳POD才算完結，其他查件結果批量更新後自動完結。',
  'K27qop': '全部導出',
  'MHwPat': '流水號',
  'P0LBOd': '處理',
  'TC+Nuc': 'POD文件',
  'd0xdq1': '查件結果文件',
  'hTgJgQ': '回復時間',
  'mItnls': '附件格式/數量:支持格式{attachmentFileFormat},每個附件不超過{attachmentSizeMax}M。(圖片上傳成功後暫不支持預覽功能)',
  'mZM5AF': '供應商說明',
  'vO6qbO': '查件結果',
  'vxR9vB': '應回復時間',
  'wdC9K4': '查件處理',
  '+P5szr': '長(CM)',
  '/CesoY': '體積(CBM)',
  '/gvpF0': '創建工單',
  '1ccOSo': '承運人',
  '46Zfck': '下載模板',
  '48tTeD': '未校驗通過或收貨倉庫不一致！',
  '6RphVF': '請上傳文件',
  '9eOwmI': '工單創建時間',
  'BqZvMO': '確認取消嗎？',
  'C3Xyt8': '箱數',
  'C5ShJS': '保存草稿',
  'DN8VBR': '工單結束時間',
  'DtBqz5': '面單/其他文件',
  'DzjlKZ': '請選擇預計發貨時間',
  'ENPgS/': '提交',
  'I0+bNm': '目的倉',
  'KLv4lM': '新增箱',
  'LURcJh': '說明:',
  'MwjxBM': '重量(KG)',
  'MxxEYf': '收起',
  'OVRt0j': '收貨倉庫',
  'Qqmpu5': '確定刪除嗎？',
  'QwslUU': '箱狀態',
  'RBartQ': '提交工單',
  'RTQq0d': '裝箱信息',
  'RyMWz0': '確認提交嗎？',
  'U17oU+': '軌跡',
  'U6zcfC': '出貨倉',
  'W5RoYI': '箱流水號/序號',
  'W9LJrj': '箱流水號',
  'Wdmil2': '展開',
  'WlP7ex': '只支持單個查詢',
  'XYdT8p': '運輸方式',
  'Xhn2gT': '請選擇',
  'XmRKnc': '備註',
  'XoAFE4': '導入成功!',
  'aDBVmD': '快遞單號',
  'bjzFIC': '預計發貨時間',
  'c2y2qR': '導入快遞單號',
  'd+Hky2': '寬(CM)',
  'eN8cMr': '重新下單',
  'egpTvD': '編輯工單',
  'fr8qvK': '文件上傳成功，請等待數據校驗結果',
  'g4ZKwz': '工單狀態',
  'gGaW5m': '請輸入備註',
  'gRcn+M': '暫無數據，點擊上方新增箱',
  'h6fo89': '批量創建工單',
  'k+30OI': '高(CM)',
  'k8/IM8': '供應商退貨管理',
  'lnucNJ': '跟蹤號',
  'lyzr6E': '雙擊批量查詢',
  'mxWvoh': '根據導入的快遞單號自動生成',
  'oH13Vj': '導入',
  'plfeJC': '批量創建工單文件',
  'pyWapc': '發貨倉庫',
  'qHs28D': '出庫單數量',
  'rtmBm+': '1. 導入文件中「*運輸方式、發貨倉庫（名稱）、收貨倉庫（名稱）、箱序號」相同默認為同一箱，導入後系統自動生成箱流水號。{break}2. 同一箱的「重量（KG）、長（CM）、寬（CM）、長+寬+高（CM）、預計發貨時間」信息必須一致{break}3. 預計發貨時間精確到分：（格式示例：2025-08-07 12:25）{break}4. 批呈創建工單為草稿狀態，請確認發貨地址是否正確後提交。',
  'sk+CM/': '工單號',
  'thGDHR': '多個單號需換行或用英文逗號隔開,最多支持{num}個,雙擊切換到單個查詢',
  'vDCwZ9': '上傳文件',
  'vNZuaz': '文件大小請勿超過{attachmentSizeMax}M',
  'vnzzbH': '導出全部',
  'vr5TVT': '請輸入',
  'zQ7jgL': '請輸入大於0最多2位小數的數字',
  'RPQXYs': '註：指物流跟蹤記錄',
  'lC02p8': '註：CBM = 立方米，貨物體積單位',
  'q5WU4o': '註：「面單」指包含交付詳情的運輸單據',
  '0fR+fE': 'Route',
  '2mTCCW': 'Current Stop',
  '47FYwb': 'Cancel',
  '5Dzxoy': '不能超過20個字符',
  '7F3IvY': 'Please select',
  '7f7PkF': 'The file format is restricted to {allowExtensions}',
  '8iYIaE': 'The current stop and the next stop cannot be the same',
  'AFBy9/': 'Please take photo of the BOL and upload it',
  'ALwUe0': '填寫幹線司機信息',
  'BIJUO+': 'Please upload the photos according to the requirements:{break}1) Capture the whole inside of the truck in one picture;{break}2) Confirm that the BOL is correctly filled out and signed',
  'BkXNm/': 'Reconfirm that the arriving time will later than ETA.',
  'BtqAem': 'Departure',
  'Ck/vXW': 'File size should not exceed {attachmentSizeMax}MB. Please compress the file before uploading',
  'Cnjc/E': '司機ID Card',
  'DqjuZJ': 'Please upload the image',
  'DrIKfG': 'You can upload up to {maxCount} files',
  'G/FVOY': '司機姓名',
  'LxCyKX': '請上傳',
  'McSzSX': '駕照號',
  'N2IrpM': 'Confirm',
  'P7PLVj': 'Date',
  'PbNtRA': '提交成功!',
  'R86IN4': 'Delay',
  'T46Urg': 'Attachment format/quantity: Supported formats: {attachmentFileFormat}. Maximum uploads: {attachmentNumMax} files. Each attachment must not exceed {attachmentSizeMax}MB.',
  'TP/Uec': 'Capture the whole inside of the truck in one picture and upload it',
  'TfnGaM': 'Next Stop',
  'V9tp+B': 'Please upload the sealed picture with clear seal number',
  'WOIPGx': 'Arrival',
  'b/lR5/': 'Pickup code',
  'hgNsC2': 'arrival',
  'p4N05H': 'Upload',
  'r4ln3K': '不能超過50個字符',
  'vMUomP': 'Upload image',
  'y1K1YT': 'The next stop and the current stop cannot be the same',
  'yy7EDI': '上傳',
  'f00p/7': 'Upload failed',
  'hsYvDX': 'Uploading',
  '+Mmw7M': '@2025 BASIC 3PL',
  '3boLWg': 'All events shown at local time',
  '3qvTiX': 'BASIC SHIPPING',
  '3rjr8i': 'More than <remaining></remaining>',
  '4CetJr': 'BASIC SHIPPING TRACKING NUMBER',
  '5JhyC0': '供应商已产生第一条有效轨 or 产生了干线轨迹 且未产生Dscan or RDscan',
  '6aD5NM': 'HIDE DETAILS',
  'ApmjIr': 'DESTINATION',
  'Cl8YLa': 'Only <remaining></remaining> more numbers can be input',
  'F84yRc': 'SHIPMENT DETAILS',
  'GgwgcO': 'SHIPPING SERVICE LEVEL',
  'OWrTNa': '根据跟踪号无法查询到数据或跟踪号对应的订单号的主账户不为18982058 - Basic 3PL, Inc.',
  'QBvgoS': 'TRACKING EVENTS',
  'S0sxA0': '供应商未产生第一条有效轨迹 且 未产生了干线轨迹',
  'UfCLZT': 'CLEAR ALL',
  'a1fAXn': 'STATUS',
  'aG5zxG': 'TRACKING NUMBER',
  'gQRAel': 'Add up to {maxCheckcount} tracking numbers separated by space, rows, commas, or semi-colons.',
  'gSlQXV': 'SHIP FROM LOCATION',
  'kcd/kl': 'LATEST UPDATE',
  'lCtyPk': 'SHIP DATE',
  'oTE2X0': 'Basic Shipping Standard',
  'qZOv9O': 'Basic Shipping Overnight',
  'rfHO5k': 'Basic Shipping Freight',
  'uCR6oy': 'Basic Shipping Economy',
  'uRh9uR': 'Basic Shipping Ground',
  'uUB5hA': '跟踪号产生了Dscan',
  'vdI05h': 'LAST MILE CARRIER',
  'vxuydz': '存在被标记为EXCEPTION类型的轨迹或RDscan',
  'wjT9XY': 'Add up to {count} tracking numbers separated by space, rows, commas, or semi-colons.',
  'xbAmTZ': 'Basic Shipping Express',
  'yLOhiN': 'TRACK',
  'Cpd1nk': '*Basic Shipping provides package tracking services only. For inquiries about order details, please contact Basic 3PL support.',
};

